import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import * as settingActions from '../../redux/settings/actions';

import Spin from '../../components/loading';
import FailedMessagesList from "../../components/failedMesasgesList";
import { formatter, validator, domManipulator, enumHelper, parser } from "../../utils";
import ENUMS from '../../enums';

import SettingValue from './SettingValue';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: [],
      errors: [],
      loaded: false,
      success: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getSettings();
  }

  componentDidUpdate(prevProps) {
    let settings = this.props.settings;

    if (prevProps.settings !== settings) {

      let errors = [];

      // set errors
      settings.forEach(setting => {
        errors.push({
          valueInputValidateStatus: '',
          valueInputInvalidMessage: ''
        });
      });

      this.setState({
        settings,
        errors
      });
    }
  }

  onValueChange = (event, index) => {
    const settings = this.state.settings;
    const errors = this.state.errors;

    const key = settings[index].key;    
    const title = settings[index].title;    
    let value = formatter.toStandard(event.target.value);
  
    // check is number
    const isNumber = validator.isNumber(value);

    if (!isNumber) {
      errors[index].valueInputValidateStatus = 'is-invalid';
      errors[index].valueInputInvalidMessage = locales('messages.fieldValueNoNumber', { 
        fieldValue: ''
      });
    }

    // find max value
    const maxValue = enumHelper.convertEnumValueToMaxValue(ENUMS.SETTING_KEYS.list, key);

    // check max value
    const hasMaxValue = isNumber && validator.hasMaxValue(value, { maxValue });
    if (isNumber && !hasMaxValue) {
      errors[index].valueInputValidateStatus = 'is-invalid';
      errors[index].valueInputInvalidMessage = locales('messages.violateMaxValue', { 
        fieldName: '',
        maxValue
      });
    }

    // remove errors
    if (value && hasMaxValue && isNumber) {
      errors[index].valueInputValidateStatus = '';
      errors[index].valueInputInvalidMessage = '';      
    }

    // set new value    
    settings[index].value = value;

    this.setState({
      settings,
      errors,
      success: false
    });
  };

  validateForm = () => {
    return new Promise((resolve, reject) => {
      let firstErrorElementId = '';
      let settings = this.state.settings;
      let errors = this.state.errors;

      for (let i = 0; i < settings.length; i++) {
        let settingItem = settings[i];
        settingItem.value = formatter.toStandard(settingItem.value);

        if (!settingItem.value) {          
          firstErrorElementId = firstErrorElementId || settingItem.id;

          errors[index].valueInputInvalidMessage = locales('messages.fieldNameIsMandatory', { fieldName: setting.title });
          errors[index].valueInputValidateStatus = 'is-invalid';
        }
      }    
      
    // check form is valid
    const isSettingsValid = errors.every(error => {
      return error.valueInputValidateStatus === '';
    });    

      let isFormValid = isSettingsValid;

      if (!isFormValid) {
        console.log("errors", errors);
        console.log("firstErrorElementId", firstErrorElementId);
        this.setState(
          () => ({
            ...errors
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          }
        );
      } else {
        resolve(true);
      }
    });
  };

  saveForm = async event => {
    event.preventDefault();

    const isFormValid = await this.validateForm();
    if (!isFormValid) {
      console.log("form is not valid");
      return;
    }

    domManipulator.scrollToTop();

    const settingObject = {
      settings: this.state.settings
    };

    this.props
      .updateSettings(settingObject)
      .then(() => {
        this.setState({
          success: this.props.success
        })
      })
      .catch(err =>
        console.error(err)
      );
  };

  render() {
    const { loading, settings } = this.props;
    return (
      <Spin spinning={loading}>
        <div>
        <section className="page-header">
          <h1>{locales('titles.settings')}</h1>
          <div className="form-actions">
            <button type="submit" className="btn btn-success w-100" onClick={event => this.saveForm(event)}>
              <i className="fa fa-save" />
              {locales('labels.save')}
            </button>
            <Link to="/" className="btn btn-default w-100">
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </Link>
          </div>
        </section>
        <section className="panel panel-default">
            <div className="panel-heading">
              <h3 className="panel-title">
                <i className="fa fa-pencil"></i>
                {locales('titles.edit.settings')}
              </h3>
            </div>
            <div className="panel-body">              
            <form ref="form" className="col form-horizontal">                
                {this.props.failed && (
                  <FailedMessagesList
                    className="errors-list"
                    messagesList={this.props.messages}
                  />            
                )}
                {this.props.error && (
                  <div className="errors-list alert alert-danger alert-dismissible fade show" role="alert">
                      {locales("messages.server.error")}
                  </div>
                )}
                {this.state.success && (
                  <div className="row">
                    <div className="col-12">
                      <div className="alert alert-success" role="alert">
                        {locales('messages.edit.success')}
                      </div>
                    </div>
                  </div>
                )}
                {settings.map((setting, index) => (
                  <SettingValue  
                    key={setting.key}                     
                    id={setting.id}
                    title={setting.title}
                    description={setting.description}
                    valueInputValidateStatus={this.state.errors.length ? this.state.errors[index].valueInputValidateStatus : ''}
                    valueInputInvalidMessage={this.state.errors.length ? this.state.errors[index].valueInputInvalidMessage : ''}
                    value={this.state.settings.length ? this.state.settings[index].value : ''}
                    onValueChange={event => {
                      this.onValueChange(event, index);
                    }}
                  />
                ))}              
              </form>       
            </div>
          </section>
        </div>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  const {
    settings,
    loading,
    message,
    messages,
    failed,
    error,
    success
  } = state.settingsReducer;

  return {
    settings,
    loading,
    message,
    messages,
    failed,
    error,
    success
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSettings: () => dispatch(settingActions.getSettings()),
    updateSettings: settingsArray => dispatch(settingActions.updateSettings(settingsArray)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Settings)
);

